<template>
  <!-- 视频详情页 -->
  <div style="width: 12.8rem; margin: 0.7rem auto 0">
    <div class="body_">
      <div class="body_left">
        <div class="body_left_video">
          <!-- <div
            :style="'background: url(' + list.filePath + ');'"
            style="
              width: 100%;
              height: 100%;
              background-position: center;
              background-size: cover;
            "
          ></div> -->
          <div class="body_left_video">
            <img :src="list.filePath" />
          </div>
          <!-- <img  :src="list.filePath" /> -->
        </div>
        <div class="body_left_title">
          {{ list.title }}
        </div>
        <div style="display: flex; justify-content: space-between">
          <div class="br_main" @click="ShadowComposerHomepage(list)">
            <img style="height: 0.5rem; border-radius: 50%"
              :src="list.avatar ? list.avatar : require('@/assets/logo.png')" />
            <div style="margin-left: 0.1rem;display: flex;flex-direction: column;justify-content: center;">
              <div class="br_main_user">
                <span style="margin-right: 0.2rem">{{
                  list.createUserName
                }}</span>
                <img v-if="userList.realStatus == 2" src="@/assets/Frame1.png" title="实名认证"
                  @click.stop="CertificationCenter" />

                <img v-if="userList.enterpriseStatus == 2" src="@/assets/Frame2.png" title="企业认证"
                  @click.stop="CertificationCenter" />
                <img v-if="userList.unionStatus == 2" src="@/assets/Frame3.png" title="联盟认证"
                  @click.stop="CertificationCenter" />
              </div>
              <view style="
                  display: flex;
                  justify-content: center;
                  margin-top: 0.05rem;
                ">
                <view class="wVC_list_l_T_B_rz" v-if="userList.professionalStatus == 2">
                  <img src="../../assets/bvlv_blue.png" />
                  标识山西认证{{ userList.profess }}
                </view>
              </view>
            </div>

            <!-- <div class="br_main_click">
							<div class="BDC_gz">关注</div>
							<div class="BDC_lxhz">联系合作</div>
						</div> -->
          </div>
          <div class="body_left_click">
            <div @click="click_sc">
              <img :src="list.isCollect == 0
                ? require('../../assets/music_b_SC.png')
                : require('../../assets/music_b_SC_OK.png')
                " />
              <span>收藏</span>
            </div>
            <div @click="click_fzlj">
              <img src="../../assets/scxx_fx.png" />
              <span>复制链接</span>
            </div>
            <div @click="module_informOverNo1" v-if="!report">
              <img src="../../assets/scxx_jb.png" />
              <span>举报</span>
            </div>
          </div>
        </div>

        <div class="body_left_fl">
          <div v-for="index in list.typeNames" :key="index" @click="pushpush(index)">{{ index }}</div>
        </div>
      </div>

      <div class="body_right">
        <!-- 选项卡 -->
        <div class="BR_Tab" v-if="list.selfPrice">
          <span @click="BR_TabClick(index, i)" v-for="(index, i) in tabList" :key="index"
            :class="index.checked ? 'BR_TabY' : 'BR_TabF'">{{ index.title }}</span>
        </div>
        <div class="BR_Tab" v-else>
          <span @click="BR_TabClick(index, i)" v-for="(index, i) in tabList1" :key="index"
            :class="index.checked ? 'BR_TabY' : 'BR_TabF'">{{ index.title }}</span>
        </div>
        <div class="BR_Tab_price">
          <span v-if="selectPrice == 0">￥{{ list.selfPrice ? (list.selfPrice / 1).toFixed(2) : 0 }}</span>
          <span v-if="selectPrice == 1">￥{{ list.enterPrice ? (list.enterPrice / 1).toFixed(2) : 0 }}</span>
          <span v-if="selectPrice == 2">￥{{ list.enterPlusPrice ? (list.enterPlusPrice / 1).toFixed(2) : 0 }}</span>
          <!-- <div>会员专享价 ￥40.00</div> -->
        </div>
        <div class="BR_Tab_message">
          {{ list.resolutionRate && list.resolutionRate }}
          <span v-if="list.resolutionRate"></span>
          {{ list.fileExt }}
          <span></span>
          {{ list.fileSize }}
        </div>
        <div class="BR_Tab_xz">
          <div @click="download" class="download">立即下载</div>
          <div @click="shoppingTrolley" class="shopping" v-if="list.selfPrice != 0">加入购物车</div>
        </div>
        <!-- <div class="BR_Tab_hy">
					<div class="BR_Tab_hy_left">
						会员免费下载
					</div>
					<div class="BR_Tab_hy_right">
						<div>升级会员</div>
						<div>获取下载次数</div>
					</div>
				</div> -->
        <div class="BR_Tab_Details">
          <div class="BR_Tab_Details_top">
            <div class="BR_TDT_left">图片素材用途</div>
            <div class="BR_TDT_right">
              <span style="margin-right: 0.12rem">授权范围</span>
              <span>授权书范本</span>
            </div>
          </div>
          <div class="BR_TDM">
            <div class="BR_TDM">
              <div class="BR_TDM_" v-for="(item, index) in use_list">
                {{ item.dictLabel }}
                <div v-if="selectPrice == 0">
                  <img style="width: 0.2rem" v-if="index > 1" src="@/assets/scxx_no.png" />
                  <img style="width: 0.2rem" v-else src="@/assets/scxx_ok.png" />
                </div>
                <div v-if="selectPrice == 1">
                  <img style="width: 0.2rem" v-if="index > 4" src="@/assets/scxx_no.png" />
                  <img style="width: 0.2rem" v-else src="@/assets/scxx_ok.png" />
                </div>
                <div v-if="selectPrice == 2">
                  <img style="width: 0.2rem" src="@/assets/scxx_ok.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="body_list">
      <div>
        <div class="SL_hotSongwriter">
          <div class="SL_hotSongwriter_title">相似素材</div>
        </div>

        <img v-if="imgLikenessList.length == 0" class="zwsj" src="../../assets/zt_zanwushuju.png" />
        <div v-else>
          <div class="SL_hotSongwriter_img_box" style="padding-bottom: 15px;">
            <div class="item_box" v-for="(item, index) in imgLikenessList" style="width: 310px;height: 260px;">
              <div class="item" @click="detail(imgLikenessList[index].id)">
                <!-- <div class="item_" :style="'background-image: url(' +
                  imgLikenessList[index].showImage +
                  ');'
                  "></div> -->
                <img :src="item.showImage" alt="" style="width: 100%;height:260px;border-radius: 12px;" srcset="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <view v-if="module_informChecked" class="module_inform">
      <view class="module_inform_body">
        <view class="module_share_body_top">
          <view>选择举报理由</view>
          <img @click="module_informOverNo" src="@/assets/module_share_open.png" />
        </view>
        <view>
          <view>
            <el-radio-group v-model="type">
              <el-row :gutter="20">
                <el-col :span="8"><el-radio label="1">违法违禁</el-radio></el-col>
                <el-col :span="8"><el-radio label="2">政治敏感</el-radio></el-col>
                <el-col :span="8"><el-radio label="3">色情低俗</el-radio></el-col>
                <el-col :span="8"><el-radio label="4">人身攻击</el-radio></el-col>
                <el-col :span="8"><el-radio label="5">垃圾广告</el-radio></el-col>
                <el-col :span="8"><el-radio label="6">刷屏</el-radio></el-col>
                <el-col :span="8"><el-radio label="7">其他问题</el-radio></el-col>
              </el-row>
            </el-radio-group>
          </view>
          <textarea placeholder="请输入举报内容" maxLength="100" v-model="reason" class="module_share_textarea"></textarea>
          <view class="module_share_button">
            <button class="module_share_button_Y" @click="handleReport">
              确定
            </button>
            <button class="module_share_button_N" @click="module_informOverNo">
              取消
            </button>
          </view>
        </view>
      </view>
    </view>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import moduleProvideMaterial from "../../components/moduleProvideMaterial.vue";
import { Axios } from "../../assets/js/ls_com_axios.js";
const router = useRouter();
const module_informChecked = ref(false);
const reason = ref("");
const type = ref("");
let id = router.currentRoute.value.query.id;
const CertificationCenter = (item) => {
  router.push({
    path: "/AuthenTicationHome",
  });
};
/* 获取当前数据接口 */
document.title = "标识山西-找素材-图片素材";
let list = ref({});
let use_list = ref([]);
const report = ref(false);
const getList = function () {
  Axios("get", "/fodder/info/" + id, false, false, function (res) {
    list.value = res.data.data;
    let a = localStorage.getItem("userList") != null ? JSON.parse(localStorage.getItem("userList")).memberId : "";
    report.value = list.value.createUser == a;
    document.title += res.data.data.title;
    playerOptions.value.sources[0].src = res.data.data.filePath;
    let uses = res.data.data.uses;
    imageUse(uses);
    likeness_other();
    getuserMassage(list.value.createUser);
  });
};
const module_informOverNo = () => {
  module_informChecked.value = false;
  type.value = "";
  reason.value = "";
};
const ShadowComposerHomepage = (item) => {
  router.push({
    path: "/ShadowComposerHomepage",
    query: {
      id: item.createUser,
    },
  });
};
const module_informOverNo1 = () => {
  module_informChecked.value = true;
};
const handleReport = function () {
  if (!type.value) {
    ElMessage.warning("请选择举报类型");
    return;
  }
  Axios(
    "POST",
    "/fodder/report",
    { materialId: id, remark: type.value },
    null,
    false,
    function (res) {
      ElMessage.success("举报成功");
      module_informChecked.value = false;
      // emit("openClickOverOpen");
    }
  );
};
getList();
const pushpush = (val) => {
  router.push({
    path: "/ShadowMaterialVideoList",
    query: {
      materialType: 'IMAGE',
      inputTitle: val
    }
  })
}
const imageUse = (uses) => {
  Axios("get", "/fodder/image-use", false, false, function (res) {
    res.data.data.forEach((item, index) => {
      if (uses) {
        const result = Object.values(item).some((val) => uses.includes(val));
        if (result) {
          item.show = true;
        } else {
          item.show = false;
        }
      } else {
        item.show = false;
      }
    });
    use_list.value = res.data.data;
  });
};

Axios("get", "/fodder/image-use", false, false, function (res) {
  console.log(res);
  use_list.value = res.data.data;
});
const tabListType = ref("SELF");

const tabList = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  },
  {
    title: "企业授权",
    authType: "ENTERPRISE",
    checked: false,
  },
  {
    title: "企业Plus",
    authType: "UNION",
    checked: false,
  },
]);
const tabList1 = ref([
  {
    title: "个人授权",
    authType: "SELF",
    checked: true,
  }
]);
const selectPrice = ref(0);
const BR_TabClick = function (index, arrI) {
  selectPrice.value = arrI;
  for (let i = 0; i < tabList.value.length; i++) {
    if (tabList.value[i] == index) {
      tabList.value[i].checked = true;
      tabListType.value = tabList.value[i].authType;
    } else {
      tabList.value[i].checked = false;
    }
  }
};
/*相似类型*/
const imgLikenessList = ref([]);
const likeness_other = () => {
  Axios(
    "get",
    "/fodder/front/list",
    {
      // isOnline: 0,
      materialType: "IMAGE",
      paramIndex: 2, //(排序方式（0默认1最新2热门）)
      status: 1,
      pageNum: 1,
      pageSize: 16,
      materialId: id,
      typeIds: list.value.typeIds,
    },
    false,
    (res) => {
      // console.log(res, '分类')
      if (res.data.rows.length == 0) {
        imgLikenessList.value = [];
      } else {
        // let new_srcList = res.data.rows;
        imgLikenessList.value = res.data.rows;
      }
    }
  );
};
/* 下载 */
const download = function () {
  Axios(
    "GET",
    "/fodder/down",
    {
      materialId: id,
    },
    false,
    function (res) {
      router.push({
        path: "/purchasedMaterial",
      });
    },
    function (res) {
      console.log(res);
      if (res.data.code == 100) {
        Axios("get", "/fodder/order/check/" + id, {}, false, (res) => {
          router.push({
            path: "/myOrderDetial",
            query: {
              arry: id,
              authType: tabListType.value,
              totalPay: 0,
              type: "order",
            },
          });
        });
      }
    }
  );
};
/* 加入购物车 */
const shoppingTrolley = function () {
  Axios(
    "POST",
    "/fodder/car",
    {
      materialId: id,
      authType: tabListType.value,
    },
    false,
    function (res) {
      ElMessage({
        showClose: true,
        message: "已加入购物车",
        type: "success",
      });
    }
  );
};
const allWorksClick = function () {
  router.push({
    path: "/ShadowMaterialVideoList",
  });
};
// 搜藏
let click_sc = function () {
  // --收藏
  if (list.value.isCollect == 0) {
    Axios(
      "post",
      "/fodder/collect",
      {
        materialId: id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已收藏",
          type: "success",
        });
        getList();
      }
    );
  } else {
    //  --取消收藏
    Axios(
      "delete",
      "/fodder/collect",
      {
        materialId: id,
      },
      false,
      function (res) {
        ElMessage({
          showClose: true,
          message: "已取消收藏",
          type: "warning",
        });
        getList();
      }
    );
  }
};
const playerOptions = ref({
  autoplay: false,
  controls: true,
  sources: [
    {
      src: "",
      type: "video/mp4",
    },
  ],
});
//跳转详情
const detail = (id) => {
  router
    .push({
      path: "/ShadowMaterialVideoImage",
      query: {
        id: id,
      },
    })
    .then(() => {
      location.reload();
    });
};
// 复制链接
const click_fzlj = function () {
  navigator.clipboard.writeText(window.location.href).then(() => {
    ElMessage({
      showClose: true,
      message: "复制成功",
      type: "success",
    });
  });
};
let userList = ref([]);
let getuserMassage = function (id) {
  Axios("GET", "/member/info/" + id, false, false, function (res) {
    userList.value = res.data.data;
  });
};
</script>

<style scoped lang="less">
.zwsj {
  width: 4rem;
  display: block;
  margin: 0 auto;
}

.body_ {
  width: 100%;
  display: flex;
  /* justify-content: ; */
}

.body_left {
  flex-grow: 1;
}

.body_left_video {
  height: 4.84rem;
  background: #000;
  position: relative;
}

.body_left_video>img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/deep/.custom-video-player,
/deep/.video-js {
  width: 100% !important;
  height: 4.84rem !important;
}

.body_right {
  width: 3.8rem;
  margin-left: 0.4rem;
}

.BR_Tab {
  display: flex;
  justify-content: space-evenly;
}

.BR_Tab {
  padding: 0.16rem 0;
  font-size: 0.14rem;
  margin-bottom: 0.2rem;
}

.BR_Tab>span {
  padding-bottom: 0.16rem;
}

.BR_TabY {
  border-bottom: 0.02rem solid #C01A26;
}

.BR_TabF {
  border-bottom: 0.02rem solid rgba(0, 0, 0, 0d);
}

.BR_Tab_price {
  display: flex;
  align-items: center;
  margin-bottom: 0.12rem;
}

.BR_Tab_price>span {
  color: #C01A26;
  font-size: 0.32rem;
  margin-right: 0.16rem;
}

.BR_Tab_price>div {
  padding: 0.04rem 0.12rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: linear-gradient(90deg, #feebd7 0%, #f8bba6 100%);
  color: #C01A26;
  font-size: 0.16rem;
  font-weight: 400;
}

.BR_Tab_message {
  color: #86909c;
  font-size: 0.12rem;
  display: flex;
  margin-bottom: 0.2rem;
}

.BR_Tab_message>span {
  width: 0.01rem;
  height: 0.15rem;
  background: #86909c;
  margin: 0 0.08rem;
}

.BR_Tab_xz {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 0.2rem;
}

.shopping {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  border: 0.01rem solid #C01A26;
  padding: 0.12rem 0.16rem;
  color: #C01A26;
  font-size: 0.14rem;
  margin-left: 0.1rem;
  cursor: pointer;
}

.download {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #C01A26;
  color: #ffffff;
  font-size: 0.14rem;
  flex-grow: 1;
  text-align: center;
  padding: 0.12rem;
  cursor: pointer;
}

.BR_Tab_Details_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.16rem;
}

.BR_TDT_left {
  color: #000000;
  font-size: 0.16rem;
}

.BR_TDT_right {
  color: #86909c;
  font-size: 0.12rem;
}

.BR_TDM_ {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.12rem;
}

.BR_TDM_>div {
  font-size: 0.14rem;
  color: #333333;
}

.BR_TDM_ span {
  color: #C01A26;
}

.BR_TDM_>img {
  width: 0.2rem;
}

.body_left_title {
  font-size: 0.24rem;
  color: #333333;
  margin-bottom: 0.08rem;
  margin-top: 0.2rem;
  line-height: 0.28rem;
}

.body_left_click {
  display: flex;
  align-items: center;
  margin-bottom: 0.24rem;
}

.body_left_click>div {
  margin-right: 0.24rem;
  font-size: 0.14rem;
  color: #333333;
  display: flex;
  align-items: center;
}

.body_left_click>div>img {
  width: 0.2rem;
}

.body_left_click>div>span {
  margin-left: 0.03rem;
}

.body_left_fl {
  display: flex;
  // padding-bottom: 0.2rem;
  // margin-bottom: 0.2rem;
  // border-bottom: 0.01rem solid #E5E6EB;
}

.body_left_fl>div {
  color: #86909c;
  font-size: 0.12rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f2f3f5;
  padding: 0.04rem 0.12rem;
  margin-right: 0.12rem;
}

.body_left_xx {
  font-size: 0.14rem;
  color: #86909c;
  margin-bottom: 0.12rem;
}

.body_left_xx>span {
  color: #333333;
  font-size: 0.14rem;
}

.SL_hotSongwriter {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  margin-bottom: 0.3rem;
}

.SL_hotSongwriter_title {
  font-size: 0.24rem;
  color: #000;
}

.SL_hotSongwriter_click {
  font-size: 0.14rem;
  color: #333;
}

.SL_offerMaterialListdiv {
  transition: all 0.5s;
  width: 3.02rem;
  position: relative;
  margin-bottom: 0.3rem;
  display: block;
  overflow: hidden;
}

.br_main {
  // border: 0.01rem solid #E5E6EB;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.08rem 0;
  display: flex;
  justify-content: flex-start;
  width: 60%;
}

.br_main>img {
  width: 0.5rem !important;
  display: block;
  // margin: 0 auto;
}

.br_main_user {
  display: flex;
  color: #000000;
  font-size: 0.14rem;
}

.br_main_user>img {
  height: 0.16rem;
}

.wVC_list_l_T_B_rz {
  color: #015243;
  background: #e1fefc;
  border-radius: 0.1rem;
  font-size: 0.12rem;
  padding: 0.02rem 0.16rem 0.02rem 0.04rem;
  display: flex;
  align-items: center;
}

.wVC_list_l_T_B_rz>img {
  width: 0.13rem;
  margin-right: 0.09rem;
}

.br_main_location {
  color: #333333;
  font-size: 0.14rem;
  border-top: 0.01rem solid #e5e6eb;
  padding-top: 0.19rem;
}

.br_main_location>img {
  width: 0.13rem;
  margin-right: 0.06rem;
  margin-left: 0.17rem;
}

.br_main_click {
  display: flex;
  justify-content: center;
  margin-bottom: 0.16rem;
}

.br_main_click>div {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
}

.BDC_gz {
  margin-right: 0.2rem;
  color: #333333;
  border: 0.01rem solid #86909c;
  background: #fff;
  cursor: pointer;
}

.BDC_lxhz {
  background: #C01A26;
  color: #fff;
  cursor: pointer;
}

/* 相似素材 */

.SL_hotSongwriter_img_box {
  // background: #CCCCCC;
  display: flex;
  // justify-content: space-between;
  column-gap: 10px;
  row-gap: 10px;
  flex-wrap: wrap;
}

.module_inform {
  background: rgba(0, 0, 0, 0.2);
  backdrop-filter: saturate(21%) blur(3px);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.module_inform_body {
  width: 4.36rem;
}

.module_share_textarea {
  width: 100%;
  resize: none;
  padding: 0.12rem 0.16rem;
  color: #86909c;
  font-size: 0.14rem;
  height: 1.04rem;
  border-radius: 0.12rem;
  margin-top: 0.32rem;
  margin-bottom: 0.2rem;
}

.module_share_button {
  display: flex;
  justify-content: center;
}

.module_share_button>button {
  padding: 0.08rem 0.3rem;
  font-size: 0.14rem;

  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
}

.module_share_button_Y {
  margin-right: 0.2rem;
  border: 0.01rem solid #333333;
  color: #333;
}

.module_share_button_N {
  color: #fff;
  background: #C01A26;
  border: 0rem solid #fff;
}

/deep/.custom-video-player,
/deep/.video-js {
  width: 100% !important;
  height: 6.3rem !important;
}

.module_share_body,
.module_inform_body {
  background: #ffffff;
  border-radius: 0.12rem 0.12rem 0.12rem 0.12rem;
  padding: 0.17rem 0.24rem;
}

.module_share_body_top,
.module_share_main {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.21rem;
}

.module_share_body_top>span {
  color: #333333;
  font-size: 0.16rem;
}

.module_share_body_top>img {
  width: 0.2rem;
}

.module_share_main {
  border-bottom: 0.01rem solid #e5e6eb;
  padding-bottom: 0.2rem;
}

.module_share_main>img {
  width: 3.8rem;
  margin-right: 0.4rem;
}

.module_share_main_title {
  text-align: center;

  font-size: 0.14rem;
  color: #333333;
  line-height: 0.16rem;
}

.module_share_main_list {
  display: flex;
  justify-content: space-around;
  margin-bottom: 0.16rem;
}

.module_share_main_list>img {
  width: 0.4rem;
}

.no_data {
  width: 100%;
  height: 160px;
}
</style>
